import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getBuilderId, getSurveyPostTourQuestions } from '../../../redux/action/action';
import { FormikProvider, useFormik } from 'formik';
import { Button } from '../../Button/Button';
import { Form, Spinner } from 'react-bootstrap';
import Footer from '../../Footer/Footer';
import { Rating } from 'react-simple-star-rating'
import { backendRoutes } from '../../../Constants/constants';
import axios from 'axios';
import { BuilderSettings } from '../../../redux/types/builders';
import FeedbackSuccessModal from './modals/FeedbackSuccessModal';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';

const tooltipArray = [
  "Terrible",
  "Terrible+",
  "Bad",
  "Bad+",
  "Average",
  "Average+",
  "Great",
  "Great+",
  "Awesome",
  "Awesome+"
];
const fillColorArray = [
  "#f17a45",
  "#f17a45",
  "#f19745",
  "#f19745",
  "#f1a545",
  "#f1a545",
  "#f1b345",
  "#f1b345",
  "#f1d045",
  "#f1d045"
];

type SaveChoiceType = {
  questionId: number;
  answerText: string;
  text: string;
  choiceId?: number;
};

const Feedback = () => {

  const history = useHistory();
	const dispatch = useDispatch();

  const [lovedFocused, setLovedFocused] = useState(false)
  const [dislikedFocused, setDislikedFocused] = useState(false)
  const [rating, setRating] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [saveChoice, setSaveChoice] = useState<SaveChoiceType[]>([]);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const builderId = useSelector((state: any) => state.builder.builder_id);
  const builderSettings: BuilderSettings = useSelector((state: any) => state.builder.settings);
  const surveyQuestions = useSelector((state: any) => state.survey.surveyPostTourQuestions);
  const loadingQuestions = useSelector((state: any) => state.survey.loading);

  const user_token = localStorage.getItem('user_token');
  const visit_id = localStorage.getItem('visit_id');
  const propertyId = localStorage.getItem('pid');

  const formik = useFormik({
    initialValues: {
      loved: '',
      disliked: '',
      rating: 0
    },
    enableReinitialize: true,
    onSubmit: async values => {

      setIsSubmitted(true);

      const unanswered = surveyQuestions.filter(
        (q: any) => !saveChoice.find(choice => choice.questionId === q.questionId)
      );

      if (unanswered.length > 0) {
        setIsError('Please answer all required questions.');
        return;
      }

      const saveChoiceComments = saveChoice
        .map(choice => `${choice.text}: ${choice.answerText}`)
        .join('\n');

      const remarks = `
      User sent feedback:

      ${values.rating} of 5 stars;

      Comments:
      Loved: ${values.loved}

      Disliked: ${values.disliked}
      
      Post Tour Survey:
      ${saveChoiceComments}`

      const formData = {
        propertyId,
        remarks,
      }
      setIsLoading(true);
      axios({
        baseURL: backendRoutes.MOBILE_BASE_URL,
        url: `visits/${visit_id}`,
        method: 'PATCH',
        headers: {
          'x-auth-token': user_token,
        },
        data: formData,
      })
        .then(res => {
          setIsLoading(false);
          setIsSubmitted(false);
          if (res.status === 200) {
            setIsError('')
            setOpenModal(true)
          }
        })
        .catch(err => {
          setIsLoading(false);
          const msg = err.response.data;
          setIsError(msg)
          console.log(msg);
        });
    },
  });

  useEffect(() => {
    !builderId && dispatch(getBuilderId());
    builderId && dispatch(getSurveyPostTourQuestions(builderId));
  }, [builderId, dispatch])

	const previousPath = () => {
		history.goBack();
	}

  const handleRating = (rate: number) => {
    setRating(rate)
    formik.setFieldValue('rating', rate);
  }

  const handleChange = (question: any, choice: any) => {
    const payload: SaveChoiceType = {
      questionId: question.questionId,
      choiceId: choice.choice_id ?? 0,
      answerText: choice.text,
      text: question.text,
    };
    const filteredChoices = saveChoice.filter(choice => choice.questionId !== question.questionId);
    setSaveChoice([...filteredChoices, payload]);
  };

  const darkenColor = (hex: string, amount: number) => {
    let col = hex.replace('#', '');
    if (col.length === 3) {
      col = col.split('').map(c => c + c).join('');
    }

    const num = parseInt(col, 16);

    let r = (num >> 16) - amount;
    let g = ((num >> 8) & 0x00FF) - amount;
    let b = (num & 0x0000FF) - amount;

    r = Math.max(0, r);
    g = Math.max(0, g);
    b = Math.max(0, b);

    return `rgb(${r}, ${g}, ${b})`;
  };

  return (
    <section className="main-section feedback-screen d-flex justify-content-center">
			<div className="box">
				<div className="main-title">
					<h1>Feedback</h1>
				</div>
				<span onClick={previousPath} className="link-back icn icn-back-arrow"></span>
				<div className="box-data d-flex flex-column">
          <p>Please rate your house tour experience!<span className='text-danger'>*</span></p>
          <Form
            className="material-form d-flex flex-column h-100"
            onSubmit={formik.handleSubmit}
            >
                <FormikProvider value={formik}>
                    <Rating
                      onClick={handleRating}
                      initialValue={formik.values.rating}
                      transition
                      emptyColor="#e7e7e7"
                      size={35}
                      showTooltip={true}
                      allowFraction={true}
                      tooltipStyle={{ color: fillColorArray[Math.ceil(rating)] }}
                      tooltipArray={tooltipArray}
                      fillColorArray={fillColorArray}
                    />

                    <Form.Group
                        className={`${ lovedFocused === false && formik.values.loved === ''
                        ? 'form-group'
                        : 'form-group input-focus'} mt-4`}
                        controlId="loved"
                    >
                        <Form.Control
                          required
                          as="textarea"
                          rows={3}
                          name="loved"
                          placeholder='Loved about this property...'
                          onChange={formik.handleChange}
                          value={formik.values.loved}
                          onFocus={() => setLovedFocused(true)}
                          maxLength={200}
                          onBlur={e => {
                            setLovedFocused(false);
                            formik.handleBlur(e);
                          }}
                        />
                    </Form.Group>

                    <Form.Group
                        className={`${ dislikedFocused === false && formik.values.disliked === ''
                        ? 'form-group'
                        : 'form-group input-focus'}`}
                        controlId="disliked"
                    >
                        <Form.Control
                          required
                          as="textarea"
                          rows={3}
                          name="disliked"
                          placeholder='Disliked about this property...'
                          onChange={formik.handleChange}
                          value={formik.values.disliked}
                          onFocus={() => setDislikedFocused(true)}
                          maxLength={200}
                          onBlur={e => {
                            setDislikedFocused(false);
                            formik.handleBlur(e);
                          }}
                        />
                    </Form.Group>
                  <div className="survey-questions">
                    {loadingQuestions ? (
                      <LoadingSpinner />
                    ) : (
                      surveyQuestions?.map((question: any, index: number) => {
                        const questionsWithChoices = question.type === 1 || question.type === 2;
                        const isAnswered = saveChoice.some(c => c.questionId === question.questionId && c.answerText !== '');

                        return (
                          <div className="survey-question-box" key={index}>
                            {question?.type !== 4 && (
                              <p>{question?.text}<span className='text-danger'>*</span></p>
                            )}
                            <div className="options-box">
                              {questionsWithChoices &&
                                question?.choices?.map((option: any, idx: number) => {
                                  return (
                                    <p
                                      key={idx}
                                      className="option-block"
                                      style={{
                                        backgroundColor: saveChoice.find(choice => choice.questionId === question.questionId && choice.choiceId === option.choice_id)
                                          ? darkenColor(builderSettings.primary_color, 20)
                                          : builderSettings.primary_color,
                                      }}
                                      onClick={() => handleChange(question, option)}
                                    >
                                      {option.text}
                                    </p>
                                  );
                                })}
                              {question.type === 3 && (
                                <>
                                  {['Yes', 'No'].map((text) => (
                                    <p
                                      key={text}
                                      className="option-block"
                                      style={{
                                        backgroundColor: saveChoice.find(choice =>
                                          choice.questionId === question.questionId &&
                                          choice.answerText === text
                                        )
                                          ? darkenColor(builderSettings.primary_color, 20)
                                          : builderSettings.primary_color,
                                      }}
                                      onClick={() => handleChange(question, { text })}
                                    >
                                      {text}
                                    </p>
                                  ))}
                                </>
                              )}
                            </div>
                            {question.type === 4 && (
                              <Form.Group controlId="text-question">
                                <Form.Control
                                  required
                                  style={{ resize: 'none', }}
                                  as="textarea"
                                  type="textarea"
                                  maxLength={200}
                                  placeholder={question?.text}
                                  name="text"
                                  onChange={(e) => handleChange(question, { text: e.target.value })}
                                />
                              </Form.Group>
                            )}
                            {question.type === 5 && (
                              <Form.Group controlId="number-question">
                                <Form.Control
                                  required
                                  type="number"
                                  placeholder="Enter Number"
                                  name="number"
                                  onChange={(e) => handleChange(question, { text: e.target.value })}
                                />
                              </Form.Group>
                            )}
                            {isSubmitted && !isAnswered && (
                              <div className="text-danger mt-1">This question is required.</div>
                            )}
                          </div>
                        );
                      })
                    )}
                  </div>

                    <div className="box-footer mt-auto">

                        {isLoading ?
                          <Button className="button w-100 d-flex justify-content-center align-items-center spinner-btn" type="button">
                            <Spinner animation="border" />
                          </Button>
                          :
                          <Button
                            disabled={
                              formik.values.rating === 0 ||
                              formik.values.loved.trim() === '' ||
                              formik.values.disliked.trim() === ''
                            }
                            style={{
                              background:
                                formik.values.rating === 0 ||
                                formik.values.loved.trim() === '' ||
                                formik.values.disliked.trim() === ''
                                  ? 'silver'
                                  : builderSettings?.primary_color
                            }}
                          className="button w-100 d-flex justify-content-center align-items-center spinner-btn"
                          type="submit">
                            Submit
                          </Button>

                          }
                    </div>
                </FormikProvider>
            </Form>
            {isError && <p className='mt-3 text-danger'>{isError}</p>}
				</div>
        <Footer />
			</div>
      <FeedbackSuccessModal
        open={openModal}
        setOpen={setOpenModal}
      />
		</section>
  )
}

export default Feedback
